import { format } from 'date-fns';

export const dateFormat = (date?: string | number | Date) => {
  if (!date) return 'no date';

  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;

  return format(dateObj, 'Pp');
};
